import { getIdOrNull } from '..';
import apiClient from './apiClient';

const URL = 'api/institution-constraints'

export const getAllInstitutionConstraints = (user, queryParams) => apiClient.get(user, URL, queryParams)
export const createInstitutionConstraint = (user, constraint) => apiClient.post(user, URL, constraint)
export const updateInstitutionConstraint = (user, constraint) => apiClient.patch(user, URL + '/' + getIdOrNull(constraint), constraint)
export const deleteInstitutionConstraint = (user, constraint) => apiClient.delete(user, URL + '/' + getIdOrNull(constraint))